import AsyncStorage from '@react-native-async-storage/async-storage';
import { logger } from './logger';

const THEME_STORAGE_KEY = '@coffeeplexity:theme_preference';

export type ThemePreference = 'light' | 'dark' | 'auto';

/**
 * Theme Storage Utility
 * Persists theme preference locally regardless of login status
 */
export const themeStorage = {
  /**
   * Get the stored theme preference
   * Returns 'auto' as default if no preference is stored
   */
  async getThemePreference(): Promise<ThemePreference> {
    try {
      const stored = await AsyncStorage.getItem(THEME_STORAGE_KEY);
      if (stored && ['light', 'dark', 'auto'].includes(stored)) {
        return stored as ThemePreference;
      }
      return 'auto';
    } catch (error) {
      logger.error('Failed to get theme preference from storage:', error);
      return 'auto';
    }
  },

  /**
   * Save the theme preference to local storage
   */
  async setThemePreference(theme: ThemePreference): Promise<void> {
    try {
      await AsyncStorage.setItem(THEME_STORAGE_KEY, theme);
      logger.debug('Theme preference saved:', theme);
    } catch (error) {
      logger.error('Failed to save theme preference:', error);
    }
  },

  /**
   * Clear the stored theme preference
   */
  async clearThemePreference(): Promise<void> {
    try {
      await AsyncStorage.removeItem(THEME_STORAGE_KEY);
      logger.debug('Theme preference cleared');
    } catch (error) {
      logger.error('Failed to clear theme preference:', error);
    }
  },
};
